import { useCallback } from 'react';
import { useGetApiDimensions, } from '../../generated/sitComponents';
/*
 * 1:   [Optional] On load of the **timesheets** page, /api/dimensions?companyId=current-sit-company-uuid
 *      This populates the cache with the dimensions for the company, the "most common" scenario,
 *      resulting in perf improvements.
 * 2.:  On **timesheet** page:
 * 2.1: If you have the companyId associated with the timesheet (stored in Redux, cache, or whatever), use the call /api/dimensions?companyId=SIT-COMPANY-ID
 *      Update the cache with the dimensions for the company: Record<SITCompanyId, DimensionsData>
 * 2.2: If you DON’T have the companyId associated with the timesheet (deep link, page reload), use the call /api/dimensions?timesheetId=SIT-TIMESHEET-ID
 *      Update the cache with the dimensions for the company: Record<SITCompanyId, DimensionsData>
 */
export function useGetDimensions({ companyId, timesheetId, projectId, taskId, }, options) {
    //   const queryClient = useQueryClient();
    // If passed a `companyId`, we can use it immediately.
    // If passed a `timesheetId`, we first try to get the `companyId` from the cache.
    // If we don't find it in the cache, we DO NOT make a request for it.
    // Instead, we use the `timesheetId` as-is.
    const qp = { activeOnly: 'true' };
    let enabled = true;
    if (companyId) {
        qp.companyId = companyId;
    }
    else if (timesheetId) {
        // TODO: Here, we should be inspecting the cache to see if we can map the `timesheetId` to a `companyId`.
        qp.timesheetId = timesheetId;
    }
    else {
        enabled = false;
    }
    if (projectId) {
        qp.projectId = projectId;
    }
    if (taskId) {
        qp.taskId = taskId;
    }
    return useGetApiDimensions({
        queryParams: qp,
    }, {
        staleTime: 1000 * 60 * 5, // 5 minutes
        ...options,
        enabled: enabled && options?.enabled !== false,
    });
}
function getDimension(dimension, name) {
    if (!dimension)
        return;
    return dimension.find((d) => d.integrationMeta?.objectName?.toUpperCase() === name.toUpperCase());
}
function selectDimensionByObjectName(data, objectName) {
    return getDimension(data, objectName)?.values ?? [];
}
export function useGetDimensionByObjectName(objectName, params, options) {
    const selectDimension = useCallback((data) => selectDimensionByObjectName(data, objectName), [objectName]);
    return useGetDimensions(params, {
        ...options,
        select: selectDimension,
    });
}
//# sourceMappingURL=use-get-dimensions.js.map